export default __webpack_public_path__ + "static/media/persons.f7b202f9.svg";